import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { ImageLinkTreeService } from '../../../services/image-link-tree.service';
import { ImageLinkTree } from '../../../models/image-link-tree';
import { ITreeOptions } from 'angular-tree-component';
import { MsImageLinkSelection } from '../../../models/ms-image-link';
// import { globals } from '../../../../globals';
import { ISubscription } from 'rxjs/Subscription';
import { AppContentsService } from '../../../services/app-contents.service';

@Component({
  selector: 'app-ms-details-content',
  templateUrl: './ms-details-content.component.html',
  styleUrls: ['./ms-details-content.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MsDetailsContentComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    sifaSectionTree: ImageLinkTree;
    sifaOtherElementTree: ImageLinkTree;
    treeOptions: ITreeOptions = {};
    descriptions: Array<string> = [];
    comments: Array<string> = [];
    descLegend: SafeHtml;
    descLegendName: string;

    constructor(
        private sanitizer: DomSanitizer,
        private manuscriptsService: ManuscriptsService,
        private imageLinkTreeService: ImageLinkTreeService,
        private appContentsService: AppContentsService
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.appContentsService.getPageContents('manuscript-card').subscribe(
                page => {
                    if (page && page.name === 'manuscript-card') {
                        const descLegend = page.contents.find(c => c.name === 'content-desc-legend');
                        if (descLegend) {
                            this.descLegendName = descLegend.name;
                            this.descLegend = this.sanitizer.bypassSecurityTrustHtml(descLegend.text);
                        }
                    }
                },
                err => console.error(err)
            ),
            this.imageLinkTreeService.getSifaSectionTree()
                .subscribe(response => this.sifaSectionTree = response, err => console.error(err)),
            this.imageLinkTreeService.getSifaOtherElementTree()
                .subscribe(response => this.sifaOtherElementTree = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptWorks()
                .subscribe(works => {
                    if (works) {
                        this.descriptions = [];
                        this.comments = [];
                        for (const work of works) {
                            for (const workCopy of work.__work_copies) {
                                if (workCopy.description) {
                                    this.descriptions.push(workCopy.description);
                                }
                                if (workCopy.comments) {
                                    this.comments.push(workCopy.comments);
                                }
                            }
                        }
                    }
                }, err => console.error(err))
        );
    }

    onEvent($event) {
        if ($event.node && $event.node.data && $event.node.data.links && $event.node.data.links.length) {
            const addParentNames = function(parentNode, parentNames: Array<string> = []): void {
                if (!parentNode.data.virtual) {
                    if (parentNames[0] && parentNames[0].indexOf(parentNode.data.name) === -1) {
                        parentNames.unshift(parentNode.data.name);
                    }
                    addParentNames(parentNode.parent, parentNames);
                }
            };

            const selectionLabel: Array<string> = [$event.node.data.name];
            addParentNames($event.node.parent, selectionLabel);
            this.manuscriptsService.selectMsImageLinks(new MsImageLinkSelection(selectionLabel.join(' - '), $event.node.data.links));
        }
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/ms-details-content/ms-details-content.component.ts